
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  LinearProgress,
  IconButton
} from '@material-ui/core';
import { CloudDownloadOutlined, Timer } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';

import CustomCard from '../../../common/CustomCard';
import VerticalDivider from '../../../common/VerticalDivider';
import UnderlineButton from '../../../common/UnderlineTextButton ';
import { useAssignmentsDetailsHeaderStyles } from './styles/AssignmentSectionStyles';

const DetailHeader = ({
  title,
  estimatedTime = '45 minutes',
  numberOfQuestions = 12,
  topics = [],
  completionPercent = 0,
  onEditClick
}) => {
  const classes = useAssignmentsDetailsHeaderStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.leftBox}>
        <Box>
          <Box className={classes.subHeader}>
            <Box className={classes.titleRow}>
              <Typography className={classes.title} noWrap>
                {title}
              </Typography>
              <IconButton size="small" aria-label="edit title" onClick={onEditClick}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box className={classes.actionRow}>
              <UnderlineButton text="View as student" onClick={() => {}} />
              <VerticalDivider />
              <UnderlineButton text="View insights" onClick={() => {}} />
              <VerticalDivider />
              <IconButton size="small" aria-label="download">
                <CloudDownloadOutlined fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          <Box className={classes.cardRow}>
            <Box className={classes.cardBox}>
              <CustomCard backgroundColor="#F6F6FB" style={{}} className={classes.maxHeightCard}>
                <Typography className={classes.completionLabel}>Class Completion</Typography>
                <LinearProgress
                  variant="determinate"
                  value={completionPercent}
                  className={classes.progressBar}
                />
                <Typography variant="body2" className={classes.percentText}>
                  {completionPercent}%
                </Typography>
                <Box className={classes.statsRow}>
                  <Box className={classes.timerBox}>
                    <Box mr={0.5}>
                      <IconButton size="small" aria-label="Timer">
                        <Timer fontSize="small" />
                      </IconButton>
                    </Box>
                    <Typography>{estimatedTime}</Typography>
                  </Box>
                  <Box className={classes.questionStats}>
                    <Typography>{numberOfQuestions} questions</Typography>
                    <Typography>10 points</Typography>
                  </Box>
                </Box>
              </CustomCard>
            </Box>

            <Box className={classes.cardBox}>
              <CustomCard backgroundColor="#F6F6FB" style={{}} className={classes.maxHeightCard}>
                <Typography className={classes.topicsCoveredLabel}>Topics covered</Typography>
                {topics.length > 0 && (
                  <Box className={classes.scrollBox}>
                    {topics.map((topic, index) => (
                      <Typography key={index} variant="body2" color="textSecondary">
                        {topic}
                      </Typography>
                    ))}
                  </Box>
                )}
              </CustomCard>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DetailHeader.propTypes = {
  title: PropTypes.string.isRequired,
  estimatedTime: PropTypes.string,
  numberOfQuestions: PropTypes.number,
  topics: PropTypes.arrayOf(PropTypes.string),
  completionPercent: PropTypes.number,
  onEditClick: PropTypes.func.isRequired
};

export default DetailHeader;
